import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-2">
      <div className="relative h-[350px] md:h-[450px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20fashion%20flat%20lay%20composition%20with%20neutral%20toned%20clothing%20items%20beige%20linen%20blazer%20cream%20trousers%20white%20sneakers%20and%20minimal%20gold%20accessories%20on%20soft%20textured%20surface%20natural%20morning%20sunlight%20from%20window%20creating%20long%20gentle%20shadows%20modern%20editorial%20aesthetic%20clean%20harmonious%20composition%20professional%20product%20photography%20high%20end%20commercial%20style%20warm%20neutral%20palette%20fresh%20sophisticated%20look%20aspirational%20lifestyle%20mood&width=900&height=600&seq=cta-left-v5&orientation=landscape"
          alt="Explore curated fashion spreadsheets"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10">
          <span className="text-xs font-medium text-white/70 uppercase tracking-wider">Discover</span>
          <h2 className="mt-2 text-3xl md:text-4xl font-heading font-bold text-white leading-tight">
            Curated Finds.<br />Zero Effort.
          </h2>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center px-8 py-16 md:py-0 bg-white text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
          Start Exploring<br />Pandabuy<span className="text-accent-500">Spreadsheet</span>
        </h2>
        <p className="mt-4 text-sm text-foreground-500 leading-relaxed max-w-sm">
          No registration required. Free access to curated lists. Updated weekly with the latest trending finds from the pandabuy spreadsheet community.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-foreground-900 text-white text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap group"
          >
            Explore All Spreadsheets
            <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <Link
            to="/pandabuy-spreadsheet-guide"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-foreground-200 text-foreground-700 text-sm font-medium rounded-full hover:bg-foreground-50 transition-all cursor-pointer whitespace-nowrap group"
          >
            Read Guide
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}